import Translator from '~/utils/Translator';

export const proPlans = (locale: string) =>
  [
    {
      id: 'free',
      title: 'Free',
      color: '#3BC47F',
      header: Translator.singular(locale, 'Available features:'),
      features: [
        {
          title: Translator.singular(locale, 'Team schedule'),
          desc: Translator.singular(
            locale,
            'Easily plan upcoming practices, games and team activities for all to see.'
          ),
        },
        {
          title: Translator.singular(locale, 'RSVP availability'),
          desc: Translator.singular(
            locale,
            'See exactly who’s available to play at a glance, with RSVPs from players and parents. Heja reminds everyone automatically!'
          ),
        },
        {
          title: Translator.singular(locale, 'Team messaging'),
          desc: Translator.singular(
            locale,
            'Communicate to your whole team at once, and see who’s read your message! Free up time by helping parents and players start communicating, too.'
          ),
        },
        {
          title: Translator.singular(locale, 'Secure & private'),
          desc: Translator.singular(
            locale,
            'Teams can only be accessed by team members, who choose which info to share and with whom.'
          ),
        },
        {
          title: Translator.singular(locale, '1 team admin'),
          desc: Translator.singular(
            locale,
            'One team member controls admin duties, but you’re free to change who holds this role.'
          ),
        },
        {
          title: Translator.singular(locale, 'Share & store documents'),
          desc: Translator.singular(
            locale,
            'Share Word, PDF and Excels easily and make them always accessible from anywhere.'
          ),
        },
      ],
    },
    {
      id: 'pro',
      title: 'Team Pro',
      color: '#372D82',
      header: Translator.singular(locale, 'Includes all Free features, plus:'),
      features: [
        {
          title: Translator.singular(locale, 'Desktop access'),
          desc: Translator.singular(locale, 'Manage your team and your schedule from your computer.'),
        },
        {
          title: Translator.singular(locale, 'Payments tracking'),
          desc: Translator.singular(locale, "Keep it all in one place, know who's paid and remind those who haven't."),
        },
        {
          title: Translator.singular(locale, 'Attendance statistics'),
          desc: Translator.singular(locale, 'Keep track of how many games and practices players attended and play.'),
        },
        {
          title: Translator.singular(locale, 'RSVP updates notification'),
          desc: Translator.singular(locale, 'Get notified when players set RSVPs and when they drop out last minute.'),
        },
        {
          title: Translator.singular(locale, 'More control over RSVPs'),
          desc: Translator.singular(
            locale,
            'Set attendee limits for activities. Members will see how many slots are available.'
          ),
        },
        {
          title: Translator.singular(locale, 'Announcement permissions'),
          desc: Translator.singular(locale, 'Enhance control with custom permissions and highlight crucial updates.'),
        },
        {
          title: Translator.singular(locale, 'Unlimited admins'),
          desc: Translator.singular(locale, 'Let an unlimited number of admins manage the team.'),
        },
        {
          title: Translator.singular(locale, 'Send powerful reminders'),
          desc: Translator.singular(
            locale,
            'Instantly remind players to RSVP, at the touch of an all-powerful button.'
          ),
        },
        {
          title: Translator.singular(locale, 'Ad-free for coaches & admins'),
          desc: Translator.singular(
            locale,
            'Keep Heja clean and make sure managers and coaches can focus easier on their job.'
          ),
        },
        {
          title: Translator.singular(locale, 'Gather feedback with Polls'),
          desc: Translator.singular(
            locale,
            'Quickly capture input from your team and keep everyone engaged in decisions and discussions.'
          ),
        },
      ],
    },
    {
      id: 'pro-max',
      title: 'Team Pro Max',
      color: 'rgb(234 179 8)',
      header: Translator.singular(locale, 'Unlimited includes all benefits of Heja Pro, plus:'),
      features: [
        {
          title: Translator.singular(locale, 'Ad free for all members'),
          desc: Translator.singular(locale, 'Remove ads for the whole team.'),
        },
      ],
    },
  ] as const;
